// components/UserListItem.js
import {
  Box,
  Button,
  ButtonGroup,
  Flex,
  Spacer,
  Tag,
  TagLabel,
  Text,
} from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { toDistanceFormatSpanish } from "utils/formatDate";
import { deleteOperario, desactiveOperario } from "services/operarios";
import { useState } from "react";
import ConfirmModal from "components/ConfirmModal";
import { FiEdit, FiEye, FiTrash } from "react-icons/fi";

const ViviendaItem = ({ user, handleToggleUser, handleRemoveUser }) => {
  const createdAtDate = user?.createdAt?.toDate();
  const createdAtDateSpanish = toDistanceFormatSpanish(
    createdAtDate || new Date()
  );
  const [isConfirmOpen, setIsConfirmOpen] = useState(false);

  const navigate = useNavigate();

  const handleViewClick = () => {
    navigate(`/viviendas/${user.id}/view`);
  };
  const handleEditClick = () => {
    navigate(`/viviendas/${user.id}/edit`);
  };

  const handleDeleteClick = () => {
    handleRemoveUser(user.id);
    setIsConfirmOpen(false);
  };

  return (
    <Box borderWidth="1px" borderRadius="lg" padding="4" width="100%">
      <Box display="flex" flexDirection={["column", "column", "column", "row"]}>
        <Box>
          <Text fontWeight="bold">{user.name}</Text>
          <Text fontSize="sm">{user.email}</Text>
          <Text fontSize="sm">{user.phone}</Text>
          {user.isActive ? (
            <Tag colorScheme="green">
              <TagLabel>Activo</TagLabel>
            </Tag>
          ) : (
            <Tag colorScheme="red">
              <TagLabel>Inactivo</TagLabel>
            </Tag>
          )}
          <Box>
            <Tag>
              <TagLabel>{createdAtDateSpanish}</TagLabel>
            </Tag>
          </Box>
        </Box>
        <Spacer />
        <ButtonGroup size="sm" mt={[5, 5, 5, 0]}>
          <Button onClick={handleViewClick}>
            <FiEye />
          </Button>
          <Button onClick={handleEditClick}>
            <FiEdit />
          </Button>

          <Button colorScheme="red" onClick={() => setIsConfirmOpen(true)}>
            <FiTrash />
          </Button>
          <ConfirmModal
            isOpen={isConfirmOpen}
            onClose={() => setIsConfirmOpen(false)}
            onConfirm={handleDeleteClick}
            title="Eliminar usuario"
            message={`¿Estás seguro de que deseas eliminar a ${user.name}?`}
          />
          <Button
            colorScheme={user.isActive ? "yellow" : "gray"}
            onClick={() => handleToggleUser(user.id, user.isActive)}
          >
            {user.isActive ? "Desactivar" : "Activar"}
          </Button>
        </ButtonGroup>
      </Box>
    </Box>
  );
};

export default ViviendaItem;
